import "reflect-metadata";
import {inject, injectable} from "inversify";
import {TaskRepository} from "@dropDesk/domain/repositories/task/task.repository";
import {TaskEntity} from "@dropDesk/domain/entities/task/tasks.entity";

@injectable()
export class SetTaskUseCase {
  private _repository: TaskRepository;

  constructor(@inject(TaskRepository) repository: TaskRepository) {
    this._repository = repository;
  }

  public call(task: TaskEntity): Promise<TaskEntity> {
    return this._repository.set(task);
  }
}

